export type AuthUser = {
  // Cognito の loginId は email エイリアス未設定時に欠落しうるため null 許容
  email: string | null;
  userId: string;
};

/** 認証後のリダイレクト先 */
export const AUTH_REDIRECT_PATH = '/tenants';

export const SIGNIN_PATH = '/signin';
